import { useEffect, useRef, useState } from 'react'
import { Alert, Loader, Input } from 'components'
import * as api from 'api'
import s from './styles.module.scss'

export default function MembershipFees() {
  const [loading, setLoading] = useState(false)
  const [planA, setPlanA] = useState('')
  const [planB, setPlanB] = useState('')
  const [planC, setPlanC] = useState('')
  const [discountA, setDiscountA] = useState('')
  const [discountB, setDiscountB] = useState('')
  const [discountC, setDiscountC] = useState('')
  const processing = useRef(false)

  const fetchSettings = async () => {
    if (processing.current) return
    processing.current = true
    setLoading(true)
    const res = await api.admin.settings.fetch({})
    if (res.code === 200) {
      const fees = res.payload.settings?.membershipFees || {}
      setPlanA(String(fees.planA ?? ''))
      setPlanB(String(fees.planB ?? ''))
      setPlanC(String(fees.planC ?? ''))
      setDiscountA(String(fees.discountA ?? 0))
      setDiscountB(String(fees.discountB ?? 0))
      setDiscountC(String(fees.discountC ?? 0))
    } else {
      Alert.error(res.message)
    }
    setLoading(false)
    processing.current = false
  }

  const save = async () => {
    if (processing.current) return
    processing.current = true
    setLoading(true)
    const body = {
      planA: Number(planA || 0),
      planB: Number(planB || 0),
      planC: Number(planC || 0),
      discountA: Number(discountA || 0),
      discountB: Number(discountB || 0),
      discountC: Number(discountC || 0)
    }
    const res = await api.admin.settings.updateMembershipFees(body)
    if (res.code === 200) {
      Alert.success('Membership fees updated')
    } else {
      Alert.error(res.message)
    }
    setLoading(false)
    processing.current = false
  }

  useEffect(() => {
    fetchSettings()
  }, [])

  return (
    <div className={s.main + ' indent'}>
      <div className={s.header}>Membership Fees</div>
      {loading ? (
        <Loader color='var(--c-primary)' colorText='var(--c-primary)' />
      ) : (
        <div className={s.form}>
          <Input.Classic label='Plan A Amount (₹)' type='number' value={planA} onChange={e => setPlanA(e.target.value)} />
          <Input.Classic
            label='Plan A Discount (₹)'
            type='number'
            value={discountA}
            onChange={e => setDiscountA(e.target.value)}
          />
          <Input.Classic label='Plan B Amount (₹)' type='number' value={planB} onChange={e => setPlanB(e.target.value)} />
          <Input.Classic
            label='Plan B Discount (₹)'
            type='number'
            value={discountB}
            onChange={e => setDiscountB(e.target.value)}
          />
          <Input.Classic label='Plan C Amount (₹)' type='number' value={planC} onChange={e => setPlanC(e.target.value)} />
          <Input.Classic
            label='Plan C Discount (₹)'
            type='number'
            value={discountC}
            onChange={e => setDiscountC(e.target.value)}
          />
          <div className={s.actions}>
            <button onClick={save}>Save</button>
          </div>
        </div>
      )}
    </div>
  )
}


